import { ITimelineElementParams } from '.'
import timelineConstants from '../../timeline.constants'

const getTimelineElementBackgroundColor = (params: ITimelineElementParams) => {
  switch (true) {
    case params.isMaintenanceInterval && params.isToday && !params.isMaintenanceDay:
      return timelineConstants.timelineColors[params.maintenanceType].timelineElementHover
    case params.isMaintenanceInterval:
      return timelineConstants.timelineColors[params.maintenanceType].timelineElement
    case params.isToday:
      return 'var(--bg-text-hover)'
    default:
      return ''
  }
}

const getTimelineElementContentBackgroundColor = (params: ITimelineElementParams) => {
  switch (true) {
    case params.isMaintenanceInterval && !params.isMaintenanceDay && params.isToday:
      return timelineConstants.timelineColors[params.maintenanceType].timelineElementPoint
    case params.isMaintenanceInterval:
      return timelineConstants.timelineColors[params.maintenanceType].timelineElementContent
    case params.isToday:
      return 'var(--text-description)'
    default:
      return 'var(--border-color)'
  }
}

const timelineElementUtils = { getTimelineElementContentBackgroundColor, getTimelineElementBackgroundColor }

export default timelineElementUtils
